import merge from 'lodash/merge';
import cloneDeep from 'lodash/cloneDeep';
import {
  cellRenderer,
  SandboxTableConfig,
  realmIdCellProps,
  checkboxCellProps,
  teamNameCellProps,
  statusCellProps,
  createdCellProps,
  creatorCellProps,
  tagsCellProps,
  archiverCellProps,
  archivedAtCellProps,
  formatActiveRealms,
  formatNonActiveRealms,
  realmsCellProps,
  tenantCellProps,
} from 'SandboxModule/components/sharedTableConfigs';
import { RealmTableView } from 'RealmModule/constants/realm';

const tableConfigs = {
  [RealmTableView.Active]: {
    cellProps: {
      headCells: [
        checkboxCellProps,
        tenantCellProps,
        realmIdCellProps,
        teamNameCellProps,
        statusCellProps,
        creatorCellProps,
        createdCellProps,
        tagsCellProps,
        realmsCellProps,
      ],
    },
    formatData: formatActiveRealms,
  },
  [RealmTableView.Archived]: {
    headerProps: {
      tableTitle: 'Archived sandbox',
    },
    cellProps: {
      headCells: [
        checkboxCellProps,
        tenantCellProps,
        realmIdCellProps,
        teamNameCellProps,
        statusCellProps,
        creatorCellProps,
        createdCellProps,
        archiverCellProps,
        archivedAtCellProps,
        tagsCellProps,
        realmsCellProps,
      ],
    },
    // Archived realms are selectable so a teardown that stalled at
    // "Partially Removed" can be retried from the UI. Row-level gating lives
    // in checkIsSandboxDestroyable (fully Removed rows stay disabled).
    shouldHideBulkActionSelector: false,
    formatData: formatNonActiveRealms,
  },
  shared: {
    cellProps: {
      cellRenderer,
      headCells: [],
    },
    headerProps: {
      tableTitle: 'Sandbox',
    },
    paginationProps: {
      hidePagination: true,
    },
    shouldHideBulkActionSelector: false,
  },
};

export const getTableConfigs = ({ variant }: { variant: RealmTableView }): SandboxTableConfig => {
  const tableConfig = cloneDeep(tableConfigs[variant]);
  const sharedConfig = cloneDeep(tableConfigs.shared);

  return merge(sharedConfig, tableConfig);
};
